var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "input-file__wrapper" },
    _vm._l(_vm.files, function (file, idx) {
      return _c("IcInputFileInput", {
        key: idx + file.name,
        staticClass: "input-file",
        attrs: { validator: _vm.v ? _vm.v.$each[idx] : null, idx: idx },
        on: {
          "file:add": _vm.addFile,
          "file:remove": function ($event) {
            return _vm.removeFile(idx)
          },
        },
        model: {
          value: _vm.files[idx],
          callback: function ($$v) {
            _vm.$set(_vm.files, idx, $$v)
          },
          expression: "files[idx]",
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }